exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".maintenance-notice{background-color:#b3090d;color:#fff;width:100%;padding:10px;z-index:100000;height:90px}.maintenance-notice p{margin:0}@media(min-width: 576px){.maintenance-notice{height:60px}}@media(min-width: 768px){.maintenance-notice{height:40px}}", ""]);

// exports
